import getAttributesForSelectedVariant, { AttributesForSelectedVariantInput } from '../../../../data-actions/common/get-attributes-for-selected-variant';
import * as React from 'react';
import classnames from 'classnames';
import { reaction } from 'mobx';

export class HSOProductName extends React.Component<any, { productName: string, productNameAttribute: string, quickView: boolean, attributeFound: boolean }> {
    public productName: string = '';
    public productNameAttribute: string = '';

    constructor(props: any) {
        super(props);
        this.state = {
            productName: props.productName,
            productNameAttribute: props.productNameAttribute,
            quickView: props.quickView,
            attributeFound: props.attributeFound
        };
    }
    public async componentDidMount(): Promise<void> {
        if(this.props.product){
            const actionInput = new AttributesForSelectedVariantInput(
                this.props.product.RecordId,
                // @ts-ignore
                +this.props.context.actionContext.requestContext.apiSettings.channelId,
                this.props.product);
    
            await getAttributesForSelectedVariant(actionInput, this.props.context.actionContext).then((result) => {
                result!.forEach(attribute => {
                    if (attribute.Name === this.state.productNameAttribute && attribute.TextValue) {
                        this.setState({ productName: attribute.TextValue});
                    }
                })
            }).catch(error => {
                console.log('error', error);
            });
        }
        else {
            this.setState({ productName: this.props.productName });
        }
    }

    public render(): JSX.Element {

        // @ts-ignore: Compiler not recognizing condition check for function params
        reaction(
            () => (this.props.product ? this.props.product.RecordId : null),
            () => {if (this.props.context && this.props.product) {  
                    const actionInput = new AttributesForSelectedVariantInput(
                        this.props.product.RecordId,
                        // @ts-ignore
                        +this.props.context.actionContext.requestContext.apiSettings.channelId,
                        this.props.product
                    );
    
                    getAttributesForSelectedVariant(actionInput, this.props.context.actionContext).then((result) => {
                        result!.forEach(attribute => {
                            if (attribute.Name === this.state.productNameAttribute && attribute.TextValue) {
                                this.setState({ productName: attribute.TextValue});
                            }
                        })
                    }).catch(error => {
                        console.log('error', error);
                    });
                }
            }
        );

        if (this.state.quickView === true) {
            if(this.state.productName && this.state.productName !== this.props.productName) {
                return (
                    <h1 className={classnames('ms-quickView__product-title')}>{this.state.productName}</h1>
                )
            }
            return (
                <h1 className={classnames('ms-quickView__product-title')}>{this.props.productName}</h1>
            )
        }
        if(this.state.productName && this.state.productName !== this.props.productName) {
            return (
                <span className='name'> {this.state.productName}</span>
            );
        }

        return (
            <span className='name'> {this.props.productName}</span>
        );


    }
}